import { useState, useEffect } from "react";
import fileService from "../../services/file";
import { Thumbnail } from "./styles";

interface ComponentProps {
  courseId: number;
  imageId: number | null;
  isCard?: boolean;
}
const Component = ({ imageId, courseId, isCard=true }: ComponentProps) => {
  const [imageUrl, setImageUrl] = useState<any>(null);

  useEffect(() => {
    const fetchCourseImage = async () => {
      try {
        if (!imageId) {
          setImageUrl(null);
          return;
        }
        const response = await fileService.getCourseFile({ id: courseId, fileId: imageId });
        if (!response) {
          throw new Error("Error al obtener la imagen del curso");
        }
        if (response) {
            setImageUrl(response)
          }
      } catch (error) {
        console.error(error);
        setImageUrl(null);
      }
    };

    fetchCourseImage();

    return () => {};
  }, [courseId, imageId]);

  return (
    <Thumbnail iscard={isCard} url={imageUrl} />
  )
};

export default Component;
